export default __webpack_public_path__ + "static/media/ponentes__Severo_Lopez_Mestre_Arana.f3ede53e.jpg";